<template>
  <canvas ref="myChartRef"></canvas>
</template>

<script>
import Chart from "chart.js";
import * as _chartType from "../../lib/chart";

const chartType = Object.assign({}, _chartType);

export default {
  name: "Chart",
  props: {
    type: {
      type: String,
      default: "bar"
    },
    labels: {
      type: Array,
      default: function () {
        return [];
      }
    },
    datasets: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      default: () => ({})
    },
    plugins: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      myChartRef: null
    };
  },
  methods: {
    newChart() {
      this.myChartRef = new Chart(this.$refs.myChartRef, {
        ...chartType[this.type].config,
        plugins: this.plugins
      });
    },
    destroyChart() {
      this.myChartRef.destroy();
    }
  },
  watch: {
    labels: {
      handler: function () {
        this.myChartRef.data.labels = this.labels;
        this.myChartRef.update();
      },
      deep: true
    },
    datasets: {
      handler: function () {
        this.datasets.forEach((dataset, index) => {
          this.myChartRef.data.datasets[index].data = dataset.data;
        });
        this.myChartRef.update();
      },
      deep: true
    }
  },
  async mounted() {
    await this.newChart();

    // 更新 labels
    this.myChartRef.data.labels = this.labels;
    // 動態更新 datasets，
    await this.datasets.forEach((dataset, index) => {
      let newDataset = {
        ...chartType[this.type].datasetConfig,
        ...dataset
      };
      this.myChartRef.data.datasets[index] = newDataset;
    });
    this.myChartRef.update();
  },
  beforeDestroy() {
    this.destroyChart();
  }
};
</script>

<style scoped></style>
